import { render, staticRenderFns } from "./AdminSettings.vue?vue&type=template&id=b86e48da&scoped=true"
import script from "./AdminSettings.vue?vue&type=script&lang=js"
export * from "./AdminSettings.vue?vue&type=script&lang=js"
import style0 from "./AdminSettings.vue?vue&type=style&index=0&id=b86e48da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86e48da",
  null
  
)

export default component.exports